// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-content[data-v-7a459d05] {\n  padding: 20px;\n  background: white;\n  border-radius: 2.5px;\n}", ""]);
// Exports
module.exports = exports;
